<template>
  <div>
    <section class="EventCards-styles-event-cards-wrapper" v-if="jackpot > 10000" v-tooltip="t.bet_jackpot_info">
      <h1 id="betpot">0.00.0</h1>
      <p>{{ t.weekly_bet_jackpot || 'Weekly BetPot' }}</p>
    </section>
  </div>
</template>

<script>
import { CountUp } from 'countup.js';
export default {
  name: "betPot",
  data () {
    return {
      t: this.$root.t,
      jackpot: 0
    }
  },
  mounted() {

    //this.fetchJackPot()
  },
  methods: {
    fetchJackPot () {
      this.$http.get(bsapi + 'api/v1/jackpot/list?id=1').then(response => {
            this.jackpot = response.body.result[0].jackpot;

        if(this.jackpot > 10000){
          setTimeout(() => {
            const options = {
              startVal: this.jackpot - ((10.8 / 100) * this.jackpot),
              duration: 360,
              decimalPlaces: 2,
            };
            let demo = new CountUp('betpot', this.jackpot, options);
            if (!demo.error) {
              demo.start();
            } else {
              console.error(demo.error);
            }
          }, 500);
        }

      })
    }
  }
}
</script>

<style scoped>
section {
  text-align: center;
  background: url(/static/assets/img/index.svg) center center / cover rgb(255, 255, 255);
  padding: 2em 2em;
  margin-top: 15px;
}
p {
  color: #fff;
  text-transform: uppercase;
  font-size: 25px;
  font-weight: 400;
}

h1 {
  color: #fff;
  font-family: 'Roboto', sans-serif;
  position: relative;
  text-transform: uppercase;
  font-size: 36px;
  font-weight: 400;
  text-shadow: 0px 0px 0 rgb(230,230,230),
  1px 1px 0 rgb(205,205,205),
  2px 2px  0 rgb(180,180,180),
  3px 3px 2px rgba(0,0,0,0.6),
  3px 3px 1px rgba(0,0,0,0.5),
  0px 0px 2px rgba(0,0,0,.2);
}

h1:after {
  background: none;
  content: attr(data-heading);
  left: 0;
  top: 0;
  z-index: -1;
  position: absolute;
  text-shadow:
      -1px 0 1px #c6bb9f,
      0 1px 1px #c6bb9f,
      5px 5px 10px rgba(0, 0, 0, 0.4),
      -5px -5px 10px rgba(0, 0, 0, 0.4);
}

</style>


// WEBPACK FOOTER //
// src/components/widget/betPot.vue